import { useEffect } from 'react'
import {gtm_code} from '../envirement';
import {loadGtmScript, load} from './common/services/script.service';
import {useTracking} from './common/hooks/useTracking';

const LoadScripts = () => {
    loadGtmScript();
    useTracking(gtm_code);

    // useEffect(() => {
    //     load('cookiebot', 'cookiebot-personal').then((res) => {
    //         // Script Loaded Successfully
    //         console.log('cookiebot loaded', res)
    //     }).catch(error => console.log(error));
    // }, [])

    return (<></>);
}

export default LoadScripts;